import { ApiBooking, ApiItem } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';

class BookingEvent extends AnalyticsBase {
  booking: ApiBooking | null = null;

  item: ApiItem | null;

  step?: string;
}

export default BookingEvent;
